
import { defineComponent, type PropType } from 'vue';
import { ITrailModel } from '@/types/routewebmodel';

export default defineComponent({
  name: 'TrailInformation',
  props: {
    trail: {
      type: Object as PropType<ITrailModel>,
      required: true,
    },
  },
  computed: {
    meerdaagsLabel() {
      if (this.trail?.meerdaags) {
        return 'Meerdaagse wandeling';
      }
      return 'Dagtocht';
    },
    rondtochtLabel() {
      if (this.trail?.rondtocht) {
        return 'Rondtocht';
      }
      return 'Lijntocht';
    },
  },
  methods: { },
});
